import React, { useState } from 'react';
import { AccordionStyled } from './AccordionStyled';
import Icon from '../icons/ReturnIcons';

const Accordion = ({ items }) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const handleItemClick = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    return (
        <AccordionStyled >
            {items.map((item, index) => (
                <div key={index} className="accordion-item ">
                    <div
                        className="accordion-heading gtm-faq"
                        onClick={() => handleItemClick(index)}
                    >
                        <span className='gtm-faq'>{item.FAQQuestion}</span>
                        <span className='iconWrapper'><Icon src={activeIndex === index ? "minusIcon" : "plusIcon"} /></span>
                    </div>
                    {activeIndex === index && (
                        <div dangerouslySetInnerHTML={{ __html: item.FAQAnswer }} className="accordion-content " />
                    )}
                </div>
            ))}
        </AccordionStyled>
    );
};

export default Accordion;



